var render = function render(_c,_vm){return _c('span',{class:_vm.props.className},[_vm._v(_vm._s(_vm.$options.methods.timeDurationFilter(_vm.props.duration, undefined, _vm.props.hours)))])
}
var staticRenderFns = []

export { render, staticRenderFns }